import { lerpColor } from '../../color';
import { hsl, type World } from '../../world';
import { dress, fx } from './dress';
import { paint } from './paint';
import './world.css';

const LENS = hsl(280, 72, 82);
const GOLD = hsl(50, 88, 78);
const MINT = hsl(170, 85, 76);
const RIM = hsl(280, 45, 92);

const world: World = {
  id: 'grande-palco',
  name: 'Grande Palco',
  seed: 'grande-palco',
  legacy: false,
  hue: 280,
  ceil: hsl(280, 27.2, 28),
  font: 'Titan One',
  fontFile: 'titan-one-400.woff2',
  fontWeight: '400',
  fontLicense: 'OFL-1.1',
  dark: true,
  boil: false,
  glow: 'add',
  glowAlpha: 0.38,
  fillAlpha: 0.72,
  palette: {
    bg: hsl(280, 34, 10),
    ink: hsl(280, 46, 5),
    rim: RIM,
    held: GOLD,
    heldShade: hsl(50, 60, 60),
    heldLight: hsl(50, 90, 90),
    incoming: { circle: LENS, square: MINT, triangle: lerpColor(LENS, GOLD, 0.5), hex: lerpColor(LENS, MINT, 0.5) },
    spot: MINT,
    path: hsl(280, 30, 72),
    text: hsl(280, 40, 94),
    sparks: [GOLD, MINT, LENS, RIM],
  },
  burst: { count: 12, speed: 0.6, drag: 3, gravity: 0.45, spin: 7, life: 1, sizeMin: 0.01, sizeMax: 0.022 },
  dress,
  fx,
  paint,
};

export default world;
